<template>
    <div class="bg-0A1129 text-white min-vh-100">
        <!-- Main Header -->
        <Mainlayout />
    
        <div class="container-fluid pt-5">
            <br /> <br /> <br />
            <div class="row p-3">
                <!-- Sidebar Menu -->
                <!-- <div class="col-md-3 mb-4">
                    <div class="p-3 custom-navy-border gradient-box text-white">
                        <CInput type="text" />
                        <div class="d-flex justify-content-between align-items-center" @click="toggleProductList" style="cursor: pointer">
                            <strong>Produk Kami</strong>
                            <img :src="isProductOpen 
                                    ? require('@/assets/img/flyhigh/chevron-up.png') 
                                    : require('@/assets/img/flyhigh/chevron-down.png')" alt="Toggle Icon" class="toggle-icon" />
                        </div>
    
                        <ul v-if="isProductOpen" class="list-group list-group-flush mt-2">
                            <li class="list-group-item bg-transparent text-white border-0 p-1">
                                <img src="../assets/img/flyhigh/classess.png" width="20px" class="mr-2" /> Kelas
                            </li>
                            <li class="list-group-item bg-transparent text-white border-0 p-1">
                                <img src="../assets/img/flyhigh/learning.png" width="20px" class="mr-2" /> Kandungan Pembelajaran & Penilaian
                            </li>
                            <li class="list-group-item bg-transparent text-white border-0 p-1">
                                <img src="../assets/img/flyhigh/pksk.png" width="20px" class="mr-2" /> PKSK / UKKM Simulasi
                            </li>
                        </ul>
    
    
    
                    </div>
    
                    <div class="mt-4 bg-101C46 p-4">
                        <CRow @click="toggleJenisList">
                            <CCol sm="10">
                                <h5>Jenis</h5>
                            </CCol>
                            <CCol sm="2">
                                <img :src="isJenisOpen
                                    ? require('@/assets/img/flyhigh/chevron-up.png') 
                                    : require('@/assets/img/flyhigh/chevron-down.png')" alt="Toggle Icon" class="toggle-icon" />
                            </CCol>
                        </CRow>
    
                        <div v-if="isJenisOpen">
                            <div class="form-check p-2">
                                <input class="form-check-input" type="checkbox" id="regular" checked>
                                <label class="form-check-label" for="regular">Regular</label>
                            </div>
                            <div class="form-check p-2">
                                <input class="form-check-input" type="checkbox" id="onoff">
                                <label class="form-check-label" for="onoff">Aktif - Tidak Aktif</label>
                            </div>
                        </div>
    
    
                        <hr style="background: var(--gray-gray-10, rgba(168, 167, 174, 0.10));" />

                        <CRow @click="toggleStandardList">
                            <CCol sm="10">
                                <h5>Standard</h5>
                            </CCol>
                            <CCol sm="2">
                                <img :src="isStandardOpen
                                    ? require('@/assets/img/flyhigh/chevron-up.png') 
                                    : require('@/assets/img/flyhigh/chevron-down.png')" alt="Toggle Icon" class="toggle-icon" />
                            </CCol>
                        </CRow>
                        <div v-if="isStandardOpen">
                            <div class="form-check p-2" v-for="grade in grades" :key="grade">
                            <input class="form-check-input" type="checkbox" :id="grade">
                            <label class="form-check-label" :for="grade">{{ grade }}</label>
                        </div>

                        </div>
                        

                        <hr style="background: var(--gray-gray-10, rgba(168, 167, 174, 0.10));" />
                        <CRow @click="toggleSubjekList">
                            <CCol sm="10">
                                <h5>Subjek</h5>
                            </CCol>
                            <CCol sm="2">
                                <img :src="isSubjekOpen
                                    ? require('@/assets/img/flyhigh/chevron-up.png') 
                                    : require('@/assets/img/flyhigh/chevron-down.png')" alt="Toggle Icon" class="toggle-icon" />
                            </CCol>
                        </CRow>
                        <div v-if="isSubjekOpen">
                        <div class="form-check p-2" v-for="sub in subjects" :key="sub">
                            <input class="form-check-input" type="checkbox" :id="grade">
                            <label class="form-check-label" :for="sub">{{ sub }}</label>
                        </div>
                    </div>
                    </div>
                </div>
     -->
                <!-- Slide Banner & Course Cards -->
                <div class="col-md-12">
    
    
                    <div class="slider-wrapper p-0 relative">
                        <!-- Left Arrow -->
                        <button class="nav-arrow left-arrow" @click="prevSlide" v-if="step > 1">
                            ‹
                          </button>
    
                        <!-- Right Arrow -->
                        <button class="nav-arrow right-arrow" @click="nextSlide" v-if="step < banners.length">
                            ›
                          </button>
    
                        <!-- Slider Content -->
                        <div class="slider p-2" :style="sliderStyle">
                            <div v-for="(screen, index) in banners" :key="index" class="slide p-2" :class="{ 'active-slide': index === step - 1 }">
                                <div class="image-container">
                                    <img :src="screen.src" class="onboarding-image" />
    
                                </div>
                            </div>
                        </div>
                        <div class="pagination mb-2">
                            <span v-for="(screen, index) in banners" :key="index" :class="{ active: index + 1 === step }" @click="goToStep(index + 1)"></span>
                        </div>
                    </div>
    
                    <!-- Course Cards -->
                    <CButton
                        type="button"
                        :class="['border-16px', selectedType === 'combo' ? 'bg-1796FD text-white' : 'bg-grey text-dark']"
                        @click="selectedType = 'combo'"
                        class="mt-3"
                        >
                        Kursus Combo
                        </CButton>

                        <CButton
                        type="button"
                        :class="['border-16px', selectedType === 'solo' ? 'bg-1796FD text-white' : 'bg-grey text-dark']"
                        @click="selectedType = 'solo'"
                        class="ml-3 mt-3"
                        >
                        Kursus Solo
                        </CButton>
                    <h4 class="mb-3 mt-5">Kursus Kombo</h4>
                    <CCol sm="12">
                        <CRow class="w-100 align-items-center">
                            <CCol sm="4" class="p-0">
                                <div class="position-relative custom-input-wrapper">
  <img src="../assets/img/search-normal.png" class="search-icon" />
  <CInput type="text" placeholder="Search..." class="custom-input-black pl-5" style="background:none;border:none"/>
</div>
                            </CCol>
                            <CCol sm="8" class="d-flex justify-content-end position-relative p-0">
                            <!-- Filter Button -->
                            <div class="position-relative">
                                <CButton
                                type="button"
                                class="custom-bg-white"
                                @click="toggleFilterOptions"
                                >
                                Filter
                                <img src="../assets/img/Filter-1.png" width="18px" class="ml-2" />
                                </CButton>

                                <!-- Dropdown Filter Panel -->
                                <div
                                v-if="showFilterOptions"
                                class="position-absolute bg-101C46 p-3 rounded shadow"
                                style="top: 110%; right: 0; width: 250px; z-index: 1000;border-radius: 24px;"
                                >
                                <!-- Produk Kami -->
                                <CInput type="text" class="mb-3" />
                               
                            
                                <!-- Jenis -->
                                <CRow @click="toggleJenisList" class="mb-2 p-2" style="cursor: pointer">
                                    <CCol sm="10"><h5>Jenis</h5></CCol>
                                    <CCol sm="2">
                                    <img
                                        :src="isJenisOpen ? require('@/assets/img/flyhigh/chevron-up.png') : require('@/assets/img/flyhigh/chevron-down.png')"
                                        alt="Toggle Icon"
                                        width="20px"
                                    />
                                    </CCol>
                                </CRow>
                                <div v-if="isJenisOpen" class="mb-3 p-2">
                                    <div class="form-check p-1">
                                    <input class="form-check-input" type="checkbox" id="regular" checked />
                                    <label class="form-check-label" for="regular">Regular</label>
                                    </div>
                                    <div class="form-check p-1">
                                    <input class="form-check-input" type="checkbox" id="onoff" />
                                    <label class="form-check-label" for="onoff">Aktif - Tidak Aktif</label>
                                    </div>
                                </div>

                                <!-- Standard -->
                                <CRow @click="toggleStandardList" class="mb-2 p-2" style="cursor: pointer">
                                    <CCol sm="10"><h5>Standard</h5></CCol>
                                    <CCol sm="2">
                                    <img
                                        :src="isStandardOpen ? require('@/assets/img/flyhigh/chevron-up.png') : require('@/assets/img/flyhigh/chevron-down.png')"
                                        alt="Toggle Icon"
                                        width="20px"
                                    />
                                    </CCol>
                                </CRow>
                                <div v-if="isStandardOpen" class="mb-3 p-2">
                                    <div class="form-check p-1" v-for="grade in grades" :key="grade">
                                    <input class="form-check-input" type="checkbox" :id="grade" />
                                    <label class="form-check-label" :for="grade">{{ grade }}</label>
                                    </div>
                                </div>

                                <!-- Subjek -->
                                <CRow @click="toggleSubjekList" class="mb-2 p-2" style="cursor: pointer">
                                    <CCol sm="10"><h5>Subjek</h5></CCol>
                                    <CCol sm="2">
                                    <img
                                        :src="isSubjekOpen ? require('@/assets/img/flyhigh/chevron-up.png') : require('@/assets/img/flyhigh/chevron-down.png')"
                                        alt="Toggle Icon"
                                        width="20px"
                                    />
                                    </CCol>
                                </CRow>
                                <div v-if="isSubjekOpen" class="p-2">
                                    <div class="form-check p-1" v-for="sub in subjects" :key="sub">
                                    <input class="form-check-input" type="checkbox" :id="sub" />
                                    <label class="form-check-label" :for="sub">{{ sub }}</label>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <!-- Subjects Button -->
                            <CButton type="button" class="custom-bg-white ml-2">Subjects</CButton>
                            </CCol>
                        </CRow>
                    </CCol>
                    
                    <div class="row">
                        <div class="col-md-4 mb-4" v-for="(course, index) in courses" :key="index">
                            <div class="border-card-black h-100 text-dark border-24px" style="padding:20px">
                                <img :src="course.image" class="card-img-top border-half-24px" alt="Course Image">
                                <div class="p-3">
                                    <br />
                                    <h6 class="custom-18px-500 text-white">{{ course.title }}</h6>
    
                                    <p class="card-text custom-20px-500 text-white"><del>{{ course.originalPrice }}</del> <strong>{{ course.discountedPrice }}</strong></p>
                                    <CButton class="bg-1796FD custom-padding text-white" style="border-radius:50px" @click="GoToDetail()">Beli Sekarang</CButton>
    
                                </div>
    
    
                            </div>
                        </div>
                    </div>
                </div>
    
           
    
            </div>
        </div>
    
        <!-- Footer -->
        <Footer />
    </div>
</template>
  
<script>
import Vue from "vue";
Vue.use(Carousel3d);
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import ToggleCard from '../components/Toggle.vue';

export default {
    name: "FlyHighHome",
    components: {
        Mainlayout,
        Footer,
        Carousel3d,
        Slide,

    },
    data() {
        return {
            step: 1,
            grades: [
                "Tingkatan 1", "Tingkatan 2", "Tingkatan 3",
                "Tingkatan 4", "Tingkatan 5", "Tahap 1",
                "Tahap 2", "Menengah Bawah", "Menengah Atas", "Terbuka"
            ],
            subjects: [
                "Bahasa Melayu", "Matematik", "Sains",
                "UPKK", "PSRA", "UKKM",
            ],
            courses: [{
                    image: require("@/assets/img/flyhigh/course1.png"),
                    title: "Tahun 3 Tropikal Premium 2025",
                    originalPrice: "MYR 740",
                    discountedPrice: "MYR 530",
                },
                {
                    image: require("@/assets/img/flyhigh/course2.png"),
                    title: "Tahun 4 Tropikal Premium 2025",
                    originalPrice: "MYR 780",
                    discountedPrice: "MYR 550",
                },
                {
                    image: require("@/assets/img/flyhigh/course3.png"),
                    title: "Tahun 5 Tropikal Premium 2025",
                    originalPrice: "MYR 800",
                    discountedPrice: "MYR 560",
                },
                {
                    image: require("@/assets/img/flyhigh/course4.png"),
                    title: "Tahun 3 Tropikal Premium 2025",
                    originalPrice: "MYR 740",
                    discountedPrice: "MYR 530",
                },
                {
                    image: require("@/assets/img/flyhigh/course5.png"),
                    title: "Tahun 4 Tropikal Premium 2025",
                    originalPrice: "MYR 780",
                    discountedPrice: "MYR 550",
                },
                {
                    image: require("@/assets/img/flyhigh/course6.png"),
                    title: "Tahun 5 Tropikal Premium 2025",
                    originalPrice: "MYR 800",
                    discountedPrice: "MYR 560",
                },
            ],
            banners: [
                { src: require('@/assets/img/flyhigh/banner1.png') },
                { src: require('@/assets/img/flyhigh/banner2.png') },
            ],
            isProductOpen: false,
            grade: [],
            isJenisOpen: true,
            isStandardOpen: true,
            isSubjekOpen:true,
            selectedType: 'combo',
            showFilterOptions: false,
        };
    },
    computed: {
        sliderStyle() {
            let slidesPerView = 1; // Default for mobile

            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                slidesPerView = 2; // Tablet (2 per slide)
            } else if (window.innerWidth >= 1024) {
                slidesPerView = 2; // Desktop (3 per slide)
            }

            return {
                transform: `translateX(-${(this.step - 1) * (100 / slidesPerView)}%)`,
                transition: 'transform 0.5s ease-in-out'
            };
        },
    },

    methods: {
        nextSlide() {
            if (this.step < this.banners.length) {
                this.step++;
            }
        },
        prevSlide() {
            if (this.step > 1) {
                this.step--;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        toggleProductList() {
            this.isProductOpen = !this.isProductOpen;
        },
        GoToDetail() {
            this.$router.push("DetailProduct");
        },
        toggleJenisList() {
            this.isJenisOpen = !this.isJenisOpen;
        },
        toggleStandardList() {
            this.isStandardOpen = !this.isStandardOpen;
        },
        toggleSubjekList() {
            this.isSubjekOpen = !this.isSubjekOpen;
        },
        toggleFilterOptions() {
            this.showFilterOptions = !this.showFilterOptions;
        }
    }
};
</script>
  
<style scoped>
.slider-wrapper {
    overflow: hidden;
    width: 100%;
}

.slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
    white-space: nowrap;
    align-items: stretch;
    /* Ensures all slides have the same height */
}

.slide::before {
    display: none !important;
}

.slide {
    min-width: 100%;
    padding: 10px;
    transition: opacity 0.5s, transform 0.5s;
    height: 100%;
    /* Ensure all slides remain the same height */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    opacity: 1 !important;
}

@media (min-width: 1024px) {
    .slide {
        min-width: calc(100% / 3);
        /* Each slide takes 1/3 of the container */
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .slide {
        min-width: 50%;
        /* Show 2 items per slide */
    }
}

.active-slide {
    opacity: 1;
    transform: scale(1);
    /* Ensure the active slide does not change in size */
}

.slide:not(.active-slide) {
    opacity: 0.6;
    /* Dim non-active slides */
    transform: scale(1);
    /* Keep all slides the same size */
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Ensure the image container takes full height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.onboarding-image {
    width: 100%;
    /* Make all images the same height */
    border-radius: 10px;
    object-fit: cover;
    /* Ensures the image maintains proportion */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Dark overlay */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    border-radius: 10px;
    color: white;
}

.pagination {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.pagination span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.pagination span.active {
    background: #fff;
}

.nav-arrow {
    position: absolute;
    top: 17%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
    font-size: 1.2rem;
    /* smaller font size */
    border: none;
    cursor: pointer;
    z-index: 10;
    padding: 0.3rem 0.6rem;
    /* smaller padding */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.left-arrow {
    left: 10px;
}

.right-arrow {
    right: 10px;
}

.nav-arrow:hover {
    background-color: rgba(0, 0, 0, 0.6);
}

.list-group-item {
    transition: all 0.3s;
}

.toggle-icon {
    width: 20px;
    height: 20px;
}

.list-group-item img {
    width: 18px;
    height: 18px;
}
</style>